module.exports = __webpack_public_path__ + "static/img/theme2.912309e2.png";